module.exports = __webpack_public_path__ + "img/hall0.7663e1c7.png";